<div class="sidebar-home">
  <div class="container-logo">
    <img [src]="getCowingLogoMenuIcon" />
  </div>
  <div class="container">
    <div
      class="nav-actions"
      *ngFor="let actions of userActions"
      (click)="redirectToPath(actions.route)"
    >
      <img [src]="actions.actionUrl" />
    </div>
  </div>
  <div class="container-logo" (click)="logOut()">
    <span>{{ "general.logout" | translate }}</span>
    <img [src]="getLogoutIcon" />
  </div>
</div>
